import { render, staticRenderFns } from "./ModalSubscriptionNewsletter.vue?vue&type=template&id=28fbedb0"
import script from "./ModalSubscriptionNewsletter.vue?vue&type=script&lang=js"
export * from "./ModalSubscriptionNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterTopFormNewsletter: require('/app/components/FooterTopFormNewsletter.vue').default})
